export const THEME_STORAGE_KEY = 'app-theme';
export const FLIX_THEME_DEFAULT = 'flix';
export const FLIX_THEME_DARK = 'flix-dark';
